import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=711cb14c&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=ts&"
export * from "./Spacer.vue?vue&type=script&lang=ts&"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=711cb14c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711cb14c",
  null
  
)

export default component.exports